/**
 * Cache tiers (00-contracts §14.4). A query picks a tier; it never invents its own numbers,
 * because a screen that feels stale and a screen that refetches on every focus are both
 * configuration mistakes rather than code mistakes.
 */
export const CACHE = {
  identity: { staleTime: 5 * 60_000, gcTime: 30 * 60_000 }, // me
  reference: { staleTime: 5 * 60_000, gcTime: 30 * 60_000 }, // departments, tags, stages
  list: { staleTime: 30_000, gcTime: 5 * 60_000 }, // contacts, tasks, threads
  detail: { staleTime: 30_000, gcTime: 5 * 60_000 },
  volatile: { staleTime: 15_000, gcTime: 2 * 60_000 }, // unread counts, badges
  immutable: { staleTime: Infinity, gcTime: 24 * 60 * 60_000 }, // legal documents, audit entries
} as const;

export type CacheTier = keyof typeof CACHE;
